/**
 * @generated SignedSource<<128ad5ecb4949d93f0cc45e2151b5987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardCardActions_view$data = {
  readonly id: string;
  readonly " $fragmentType": "BoardCardActions_view";
};
export type BoardCardActions_view$key = {
  readonly " $data"?: BoardCardActions_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardCardActions_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardCardActions_view",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "643a2d05820d51e33d5a9cfbb4d16726";

export default node;
